/*
================================================================================
File: src/constants/views.js
Description: Defines constants for different views/pages in the application.
================================================================================
*/
export const views = {
  login: "login",
  register: "register",
  dashboard: "dashboard",
  admin: "admin",
  history: "history",
  seller: "seller",
  investor: "investor",
  settings: "settings",
  sellerSites: "sellerSites",
  training: "training",
  ecommerce: "ecommerce",
  links: "links",
  support: "support",
  editLead: "editLead",
  sellerEditScreen: "sellerEditScreen",
};
